var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('menu-panel',{attrs:{"raiz":"/panel/","vistas":_vm.Vistas},on:{"on-log-out":function($event){return _vm.logOut()}}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }